import styled from '@emotion/styled'

export const WozCheckResultWrapper = styled.div(({ theme }) => ({}))

export const ResultMessage = styled('div', {
  shouldForwardProp: prop => prop !== 'resultIsPositive',
})<{ resultIsPositive: boolean }>(({ theme, resultIsPositive }) => ({
  width: '100%',
  padding: 16,
  borderRadius: 6,
  backgroundColor: resultIsPositive ? theme.colors.Y400 : theme.colors.B50,
  color: resultIsPositive ? theme.colors.N0 : theme.colors.B500,
  margin: '24px 0px',
}))

export const SavingsOrValueWrapper = styled.div(({ theme }) => ({
  borderRadius: 4,
  backgroundColor: theme.colors.N20,
  padding: '8px 16px',
  marginTop: 4,
  marginBottom: 24,
  color: theme.colors.N500,
  '&.savings': {
    marginBottom: 0,
  },
}))

export const Row = styled.div(({ theme }) => ({
  display: 'flex',
  height: 40,
  alignItems: 'center',
  justifyContent: 'space-between',
  '&.fee': {
    borderTop: '1px solid #cacccf',
    marginTop: 8,
    paddingTop: 8,
  },
  '&.total': {
    backgroundColor: theme.colors.G300,
    color: '#fff',
    marginTop: 24,
    marginBottom: 24,
    padding: 16,
    height: 56,
    borderRadius: 4,
  },
}))

export const Column = styled('div', {
  shouldForwardProp: prop => prop !== 'isTotalField',
})<{ isTotalField?: boolean }>(({ theme, isTotalField }) => ({
  display: 'flex',
  '& svg': {
    marginRight: 10,
    cursor: 'pointer',
    flexShrink: 0,
    flexGrow: 0,
    width: 16,
    height: 16,
  },
  maxWidth: '50%',
  fontSize: isTotalField ? theme.fontSizes.mobile.body : theme.fontSizes.mobile.small,
  fontWeight: isTotalField ? theme.fontWeights.semibold : theme.fontWeights.body,
  [theme.breakpoint.up('md')]: {
    fontSize: isTotalField ? theme.fontSizes.desktop.h2 : theme.fontSizes.desktop.body,
  },
  [theme.breakpoint.up('xs')]: {
    fontSize: isTotalField ? theme.fontSizes.mobile.h2 : theme.fontSizes.mobile.body,
  },
}))

export const WozAdviserWrapper = styled.div(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  background: '#f8f9fa',
  padding: '8px',
  borderRadius: '4px',
}))

export const ImageWrapper = styled.div(({ theme }) => ({
  marginRight: 16,
  '& img': {
    width: 64,
    height: 64,
    borderRadius: '50%',
  },
}))

export const TextWrapper = styled.div(({ theme }) => ({
  color: theme.colors.N900,
  '& .small': {
    color: theme.colors.N100,
  },
  '& p': {
    marginTop: '0 !important',
  },
  '& .phone': {
    color: theme.colors.B300,
    fontWeight: theme.fontWeights.medium,
    '& a': {
      color: 'inherit',
    },
  },
}))

export const ContentWrapper = styled.div(({ theme }) => ({
  color: theme.colors.N600,
  marginBottom: 24,
}))

export const WozAdviserHeader = styled.h2(({ theme }) => ({
  marginTop: 24,
  marginBottom: 8,
  color: theme.colors.N700,
}))

export const BulletList = styled.ul(({ theme }) => ({
  margin: 0,
  marginTop: 24,
  backgroundColor: theme.colors.G50,
  borderRadius: 6,
  padding: 16,
  listStyle: 'none',
  '& h3': {
    marginBottom: 8,
  },
  '& li': {
    color: theme.colors.N500,
    display: 'flex',
    alignItems: 'center',
    '&:not(:last-child)': {
      marginBottom: 8,
    },
    '& svg': {
      marginRight: 11,
      width: 18,
      height: 18,
      flexShrink: 0,
    },
  },
  [theme.breakpoint.down('md')]: {
    '& h3': {
      fontSize: theme.fonts.pxToRem(18),
      lineHeight: 24 / 18,
    },
    '& li': {
      '& svg': {
        width: 15,
        height: 15,
      },
    },
  },
}))

export const FeeWrapper = styled.div(({ theme }) => ({
  marginTop: 24,
  marginBottom: 24,
  paddingTop: 48,
  borderTop: '1px solid #DFE1E6',

  '& > h2': {
    marginBottom: 8,
  },
}))

export const Avatar = styled.div(({ theme }) => ({
  marginRight: 16,
  width: 64,
  borderRadius: '50%',
  background: '#e0e4eb',
  textAlign: 'center',
  lineHeight: '64px',
  fontSize: 15,
  fontWeight: 500,
  color: '#7A869A',
}))
